import { render, staticRenderFns } from "./amazonShipwork.vue?vue&type=template&id=f2391252&scoped=true"
import script from "./amazonShipwork.vue?vue&type=script&lang=js"
export * from "./amazonShipwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2391252",
  null
  
)

export default component.exports